/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Column } from '@g17eco/molecules/tracking-list';
import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import { Answer } from '../../types';

export const ColumnStatusIcon = (props: ColumnCommonProps & {
    answer?: Answer;
}) => {
  const { answer } = props;
  return (
    <Column {...props}>
      <div className='p-2 d-flex align-items-center justify-content-center text-center' style={{ width: '3rem', minWidth: '3rem' }}>
        <StatusIcon status={answer?.status} confidence={answer?.confidence} />
      </div>
    </Column>
  );
};

function StatusIcon({ status, confidence }: { status?: string, confidence?: number }) {
  if (status === 'pending') {
    return <i className='fal fa-clock text-ThemeTextMedium' style={{ fontSize: '1rem' }} />;
  }
  if (status === 'processing') {
    return <i className='fal fa-spinner fa-spin text-primary' style={{ fontSize: '1rem' }} />;
  }
  if (status === 'completed') {
    const icon = !confidence ? 'fal fa-exclamation-triangle' : confidence < 90 ? 'fal fa-exclamation-circle' : 'fal fa-check-circle';
    const color = !confidence ? 'text-ThemeNeutralsMedium' : confidence < 50 ? 'text-ThemeDangerMedium' : confidence < 90 ? 'text-ThemeWarningMedium' : 'text-ThemeSuccessMedium';
    return <i className={`fal ${icon} ${color}`} style={{ fontSize: '1rem' }} />;
  }
  if (status === 'failed') {
    return <i className='fal fa-exclamation-circle text-danger' style={{ fontSize: '1rem' }} />;
  }
  return <i className='fal fa-fw' style={{ fontSize: '1rem' }} />;
}
